'use client';

import { SearchIcon } from '@wolfejs/icons/IconMap';
import { Input } from '@wolfejs/ui/Input';
import type { PGCorpProduct } from 'apps/portals/src/types/products';

const SearchInput = ({ search, setSearch }: { search: string; setSearch: (s: string) => void }) => {
  return (
    <Input
      className="min-w-[250px]"
      placeholder="Search for the perfect gift..."
      value={search}
      onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearch(e.target.value)}
      prepend={<SearchIcon className="text-default-300 h-4 w-4" />}
    />
  );
};

const ProductGridHeader = ({
  products,
  search,
  setSearch,
  page,
  limit,
  count,
}: {
  products: PGCorpProduct[];
  page: number;
  limit: number;
  search: string;
  setSearch: (s: string) => void;
  count: number;
}) => {
  const from = Number(page) * Number(limit) - limit + 1;
  const to = Number(page) * Number(limit);
  const range = count <= 0 ? 0 : `${from} - ${to > count ? count : to}`;
  return (
    <div className="mb-4 flex items-center justify-between">
      <div>
        <h1 className="text-2xl font-semibold text-gray-800">All Results</h1>
        <div className="text-sm text-gray-500">
          Showing {range} of {count} items
        </div>
      </div>
      <div className="flex gap-2">
        <SearchInput search={search} setSearch={setSearch} />
      </div>
    </div>
  );
};

export default ProductGridHeader;
